import React from "react";
import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { txtA, txtE } from "../../../../Label/Lbl";
import { getTotalAmount } from "../../../../utils/utils";
import "../riyals.css"
import { useInvAF } from "../../../../St/Reviews/UseStyle";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
import tafqeet from "../../../../utils/tafqeet";

const useStyles = makeStyles((theme) => ({
    container: {
        width: "100%",
        border: "1px solid #888",
        borderRadius: 0,
        boxShadow: "none",
        overflow: "hidden",
        backgroundColor: "#fff",
        // direction: "ltr",
        fontFamily: "Arial, sans-serif",
    },

    table: {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
    },

    cell: {
        border: "1px solid #888",
        padding: "0px 0px",
        // height: 33,
        boxSizing: "border-box",
        fontSize: 15,
        fontWeight: 600,
        color: "#252525",
        lineHeight: 1.4,

        [theme.breakpoints.down("xs")]: {
            padding: "1px 1px",
            fontSize: 11,
            overflowWrap: "anywhere",
        },
    },

    englishCell: {
        width: "43%",
        textAlign: "left",
        direction: "ltr",
        paddingLeft: "5px",
        paddingTop: "0px",
        paddingRight: "0px",
        paddingBottom: "0px",
        fontSize:"14px"
    },

    arabicCell: {
        width: "43%",
        textAlign: "right",
        direction: "rtl",
        paddingLeft: "0px",
        paddingTop: "0px",
        paddingRight: "5px",
        paddingBottom: "0px",
        fontSize:"14px"
    },

    amountCell: {
        width: "14%",
        textAlign: "right",
        direction: "ltr",
        padding: "0px",
        paddingLeft: "0px",
        paddingTop: "0px",
        paddingRight: "5px",
        paddingBottom: "0px",
        whiteSpace: "nowrap",
    },

    headerCell: {
        backgroundColor: "#ededed",
        fontWeight: 700,
    },

    amountContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 12,
        whiteSpace: "nowrap",

        [theme.breakpoints.down("xs")]: {
            gap: 4,
        },
    },

    currency: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 24,
        flexShrink: 0,
        fontSize: 22,
        fontWeight: 700,
        lineHeight: 1,

        [theme.breakpoints.down("xs")]: {
            width: 16,
            fontSize: 15,
        },
    },

    amount: {
        minWidth: 90,
        textAlign: "right",
        color: "#f00",
        fontVariantNumeric: "tabular-nums",
        fontWeight: 700,

        [theme.breakpoints.down("xs")]: {
            minWidth: 0,
        },
    },

    totalRow: {
        "& td": {
            fontWeight: 700,
        },
    },
}));


const totalsRe_Disc = (sta, tax, locInv) => [
    {
        id: 1,
        en: "Total (Excluding VAT)",
        ar: "الإجمالي (باستثناء ضريبة القيمة المضافة)",
        amount: locInv?.invs?.tot_sale,
    },
    {
        id: 6,
        en: txtE.discount,
        ar: "خصم دفعة مقدمة",
        amount: sta.tot.discount,
    },
    {
        id: 7,
        en: "Total Taxable Amount",
        ar: "الإجمالي الخاضع للضريبة",
        amount: locInv?.invs?.amountAfterDisc,
    },
    {
        id: 2,
        en: "Total VAT:",
        ar: "إجمالي ضريبة القيمة المضافة" + " " + "( " + `${tax}` + "%" + ") ",
        amount: sta.tot.amountOfVat,
    },
    {
        id: 3,
        en: txtE.tot_net,
        ar: "الإجمالي شامل الضريبة",
        amount: sta.tot.tot_net + locInv.invs?.re_disc_minus,
    },
    {
        id: 5,
        en: "Retention Amount",
        ar: "مبلغ خصم ضمان الأعمال",
        amount: locInv.invs?.re_disc_minus,
    },
    {
        id: 6,
        en: "Net Amount Payable",
        ar: "الصافي المطلوب دفعه",
        amount: sta.tot.tot_net,
    },
];
const totals = (sta, tax) => [
    {
        en: "Total (Excluding VAT)",
        ar: "الإجمالي (باستثناء ضريبة القيمة المضافة)",
        amount: getTotalAmount(sta.tot),
    },
    {
        en: txtE.discount,
        ar: txtA.discount,
        amount: sta.tot.discount,
    },
    {
        en: "Amount After Discount",
        ar: "الاجمالي بعد الخصم",
        amount: getTotalAmount(sta.tot) - sta.tot?.discount,
    },
    {
        en: "Total VAT:",
        ar: "إجمالي ضريبة القيمة المضافة" + " " + "( " + `${tax}` + "%" + ") ",
        amount: sta.tot.amountOfVat,
    },
    {
        en: txtE.tot_net,
        ar: txtA.tot_net,
        amount: sta.tot.tot_net,
    },
];
const formatAmount = (value) =>
    Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export default function InvTotalsComs(props) {
    const { found, sta, inv, locInv } = props;
    const clas = useInvAF();

    const classes = useStyles();
    const totalsAll = () => {
        if (sta?.tot?.re_disc) {
            return totalsRe_Disc(sta, inv.tax, locInv);
        } else {
            return totals(sta, inv.tax);
        }
    };
    const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1rem", BorderBottom: "solid 1px" };

    return (
        <div style={{ paddingTop: "0.5rem",direction:"rtl" }}>
            <TableContainer component={Paper} className={classes.container}>
                <Table className={classes.table} aria-label="Invoice totals">

                    <TableBody >
                        <TableRow>

                            <TableCell
                                className={`${classes.cell} ${classes.amountCell} ${classes.headerCell}`}
                                colSpan={1}
                            >
                                {formatAmount(sta.tot.tot_net)}
                            </TableCell>
                            <TableCell
                                className={`${classes.cell} ${classes.englishCell} ${classes.headerCell}`}
                                colSpan={2} style={{ direction: "rtl" }}
                            >
                                {["RS", "SAR", "SR"].includes(sta?.omlat[0]?.symbol) ?
                                    (<Grid container item xs={9} > <div style={styleNameA}>{tafqeet(sta.tot.tot_net, "SAR")}</div></Grid>) :
                                    (<Grid container item xs={9} > <div style={styleNameA}>{tafqeet(sta.tot.tot_net, "USD")}</div></Grid>)}
                            </TableCell>

                        </TableRow>
                        {totalsAll().map((row) => (
                            <TableRow key={row.en}>
                                <TableCell
                                    className={`${classes.cell} ${classes.amountCell}`}
                                >
                                    <div className={classes.amountContent}>
                                        {row?.id != 4 && ["RS", "SAR", "SR", "ريال سعودي"].includes(sta?.omlat[0]?.symbol) &&
                                            <span style={{ fontFamily: "SaudiRiyal", fontSize: 20 }}>{"\u20C1"}</span>
                                        }
                                        <span className={classes.amount}>
                                            {formatAmount(row.amount)}
                                        </span>
                                    </div>
                                </TableCell>
                                <TableCell
                                    className={`${classes.cell} ${classes.arabicCell}`}
                                >
                                    {row.ar}
                                </TableCell>

                                <TableCell
                                    className={`${classes.cell} ${classes.englishCell}`}
                                >
                                    {row.en}
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item container style={{ fontFamily: "Amiri-Regular" }}>
                {(found.BillNotes != "...." && found.BillNotes != null && found.BillNotes != "")
                    && (
                        <Grid
                            item
                            container
                            xs={12}
                        >
                            <Grid item xs={12}>
                                <div style={{ direction: "ltr", fontWeight: "bold", textAlign: "right" }}> {"Desscription / "}{"البيان"}</div>
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word',
                                    fontWeight: "bold",
                                    direction: "rtl",
                                    fontFamily: "Amiri-Regular",
                                    textAlign: "right"
                                }}>
                                    {inv.notes}
                                </div>
                            </Grid>
                            {locInv?.salesmanName != "" && locInv?.salesmanName != null &&
                                <Grid container item xs={12} style={{ direction: "rtl", fontWeight: "bold" }}>
                                    {"المندوب / "}{locInv?.salesmanName}
                                </Grid>
                            }
                        </Grid>
                    )}

            </Grid>

        </div>
    );
}